/**
 * Hybrid Ask Cenna router: rewrite / rephrase → add-in chat; hub Q&A / tools → assistant SSE.
 */

export type ChatIntentPath = "add_in" | "assistant";

const REWRITE_RE =
  /\b(rephrase|rewrite|re\-write|shorten|simplify|formaliz|formalise|grammar|grammatical|typo|suggest\s+edits?|suggest\s+alternatives?|make\s+(this|it)\s+(more|less)|improve\s+(this|the|wording|language)|replace\s+(this|the)|edit\s+(this|the)|redline|track\s*changes?)\b/i;

const PLAYBOOK_REWRITE_RE =
  /\b(align|comply|compliance|match|per|according\s+to|wrt|with\s+respect\s+to).{0,40}\bplaybook\b|\bplaybook\b.{0,40}\b(rephrase|rewrite|align|comply|edit|suggest)\b/i;

/**
 * Route a user message to the add-in rewrite path or Contract Hub assistant SSE.
 *
 * Playbook-aware rewrites stay on add-in so suggestion Insert cards still work.
 */
export function routeChatIntent(query: string, selectedText: string | null | undefined): ChatIntentPath {
  const q = (query || "").trim();
  const sel = (selectedText || "").trim();

  if (!q) {
    return sel ? "add_in" : "assistant";
  }

  if (PLAYBOOK_REWRITE_RE.test(q)) {
    return "add_in";
  }

  if (REWRITE_RE.test(q)) {
    return "add_in";
  }

  // Selection + vague edit ask (chip: "Suggest edits for the selected text")
  if (sel && /\b(suggest|edit|fix|change|update|improve)\b/i.test(q) && q.length < 120) {
    return "add_in";
  }

  return "assistant";
}
